module.exports = __webpack_public_path__ + "img/security_voltage_fault.4bd87959.svg";